import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
const AuditComment = (props) => {
    const { comment: { authorType, timestamp, message }, } = props;
    const containerClassNames = classnames({
        'p-6': 1,
        'text-white': authorType && authorType !== 'Shipper',
        'text-grey-darker': !authorType || authorType === 'Shipper',
        'bg-grey-lightest': !authorType || authorType === 'Shipper',
        'bg-green': authorType === 'Admin' || authorType === 'Automated',
        'bg-blue': authorType === 'Carrier',
        'bg-yellow-600': authorType === 'Vendor',
        rounded: 1,
        shadow: 1,
    });
    const authorTypeClassNames = classnames({
        'bg-grey-light': !authorType || authorType === 'Shipper',
        'bg-green-light': authorType === 'Admin' || authorType === 'Automated',
        'bg-blue-light': authorType === 'Carrier',
        'bg-yellow-50': authorType === 'Vendor',
        rounded: 1,
        'px-4': 1,
    });
    function renderAuthor(comment = {}) {
        if (['Admin', 'Carrier', 'Shipper'].includes(comment.author) &&
            comment.email) {
            return comment.email;
        }
        return comment.author;
    }
    return (React.createElement("div", { "data-testid": "div-37dc6bff", className: containerClassNames },
        React.createElement("div", { "data-testid": "div-0d573f29", className: "flex justify-between" },
            React.createElement("div", { "data-testid": "div-8aab7261" },
                React.createElement("span", { "data-testid": "span-daa945c5", className: "font-bold" }, renderAuthor(props.comment)),
                React.createElement("span", { "data-testid": "span-b026d600", className: "mx-1" }, "\u00B7"),
                React.createElement("span", { "data-testid": "span-b87be371" }, moment(timestamp).format('LLLL'))),
            React.createElement("div", { "data-testid": "div-a1e0bee4" },
                React.createElement("span", { "data-testid": "span-3b6a205c", className: authorTypeClassNames }, authorType))),
        React.createElement("div", { "data-testid": "div-348b5d4a", className: "flex w-3/4" },
            React.createElement("span", { "data-testid": "span-597c2685", className: "break-words whitespace-pre-wrap" }, message))));
};
const AuditComments = (props) => {
    const { t } = useTranslation();
    const { dataTestId } = props;
    if (!props.comments || !props.comments.length)
        return null;
    const comments = props.comments;
    return (React.createElement("div", { "data-testid": dataTestId, className: "flex-col", style: { width: '100%' } },
        React.createElement("div", { "data-testid": "div-e2de10e7", style: { display: 'block' } },
            React.createElement("h4", { "data-testid": "h4-121a48f8", className: "text-grey-darker" }, t('HISTORY'))),
        React.createElement("div", { "data-testid": "div-20f09b60", className: "overflow-y-scroll", style: { maxHeight: 550 } }, comments.map((c, index) => {
            return (React.createElement("div", { "data-testid": `div-42b7e34b-${index}`, className: "flex pb-2", key: index },
                (c.authorType === 'Carrier' || c.authorType === 'Vendor') && (React.createElement("div", { "data-testid": `div-63ec0f9f-${index}`, className: "w-1/3" }, "\u00A0")),
                React.createElement("div", { "data-testid": `div-de3b716b-${index}`, className: "w-2/3 overflow-x-scroll" },
                    React.createElement(AuditComment, { comment: c }))));
        }))));
};
export default AuditComments;
